/**
 * Validates that a string is a valid MongoDB ObjectId (24 hex characters).
 * Used for route param validation (e.g. contactId, projectId) before rendering detail pages.
 */
export function isValidMongoId(id: string | undefined): id is string {
  if (id == null || typeof id !== 'string') return false;
  return /^[0-9a-fA-F]{24}$/.test(id);
}
